import {
  initialState,
  Actions,
  State,
  GET_WELCOME_CONTENT_POST,
  GET_WELCOME_CONTENT_POST_SUCCESS,
  GET_WELCOME_CONTENT_POST_ERROR,
  RESET_GET_WELCOME_CONTENT_POST,
  UPDATE_CURRENT_WELCOME_CONTENT,
} from "../../types/welcome-content/get-welcome-content-post";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_WELCOME_CONTENT_POST:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_WELCOME_CONTENT_POST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_WELCOME_CONTENT_POST_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case UPDATE_CURRENT_WELCOME_CONTENT:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case RESET_GET_WELCOME_CONTENT_POST:
      return { ...initialState };
    default:
      return state;
  }
};

export default reducers;
